<script setup lang="ts">
import { watch } from 'vue';
import { useRoute } from 'vue-router';

import Button from 'primevue/button';
import Card from 'primevue/card';

import DefaultInput from '../components/DefaultInput.vue';

import { useAddCalculation } from '../composables/useAddCalculation';

const { name, handleAddCalculation } = useAddCalculation();

const route = useRoute();
watch(
  () => route.path,
  () => {
    setTimeout(() => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }, 50);
  },
  {
    immediate: true,
  }
);
</script>

<template>
  <Card class="h-max flex-1 basis-[354px] border border-gray-200 !shadow-none">
    <template #content>
      <section v-auto-animate class="">
        <form class="space-y-9" @submit.prevent="handleAddCalculation">
          <DefaultInput placeholder="Wpisz nazwę kalkulacji" v-model="name">
            Nazwa kalkulacji
          </DefaultInput>

          <div class="flex justify-center gap-6">
            <RouterLink
              :to="{
                name: 'ClientView',
                params: {
                  ...$route.params,
                },
              }"
            >
              <Button class="font-semibold" severity="secondary" outlined size="small">
                Wstecz
              </Button>
            </RouterLink>

            <Button type="submit" class="font-semibold" size="small" :disabled="name.length < 4">
              Dodaj technologię
              <i class="pi pi-arrow-right"></i>
            </Button>
          </div>
        </form>
      </section>
    </template>
  </Card>
</template>
